<template>
  <section class="scrollable">
    <div class="block block__me">
      <div
        class="header header__first d-flex justify-content-center align-items-center"
      >
        <div class="pt-4 pb-3 text-left">
          <blockquote>
            Those people who are crazy enough to think they can change the world
            are the ones that actually do.
          </blockquote>
          <small class="copyright">© Steve Jobs</small>
          <a href="#me">about me</a>
        </div>
      </div>
      <div id="me" class="about-block about-block__first">
        <div class="container-lg py-4">
          <div class="row white no-gutters justify-content-center">
            <div class="col-md-6 text-right">
              <div class="img-wrap">
                <img src="@/assets/img/me.jpg" />
              </div>
            </div>

            <div class="col-md-6 py-4 py-md-0 text-left">
              <div class="info">
                <h1>Hi. I'm Vitalii</h1>
                <h2>
                  A software engineer with a passion for startups and
                  entrepreneurship
                </h2>
                <p>
                  <b>My cause</b> is to change the world by building top-tier
                  products for innovators and companies with a good cause.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block block__intro container-fluid px-0">
      <div class="header d-flex justify-content-center align-items-center">
        <h1>My journey</h1>
      </div>
      <div class="about-block">
        <div class="container-lg py-4">
          <div
            class="row timeline py-2 justify-content-between align-items-end"
          >
            <div class="col-12 col-md-3 py-2 text-left">
              <div class="white px-4 py-3" data-info="2012">
                <p>
                  Got into web development at age 18
                  <small>and been hooked ever since.</small>
                </p>
              </div>
            </div>
            <div class="col-12 col-md-3 py-2 text-left">
              <div class="white px-4 py-3" data-info="2012-2018">
                <p>
                  Worked at different IT companies and solved tech problems for
                  a lot of great products.<br />
                  <small
                    >Although I believe my best product is yet to be
                    built.</small
                  >
                </p>
              </div>
            </div>
            <div class="col-12 col-md-3 py-2 text-left">
              <div class="white px-4 py-3" data-info="2018">
                <p>
                  Started a freelance career.<br />
                  <small
                    >First - as an extension of my day job. But a year after - I
                    went full-time</small
                  >
                </p>
              </div>
            </div>
            <div class="col-12 col-md-3 py-2 text-left">
              <div class="white px-4 py-3" data-info="2019-now">
                <p>
                  Rocking on with a cause of changing the world for better.
                  <br />
                  <small
                    >It's still a work in progress, so don't worry if you can't
                    see any difference yet 😉</small
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block block__why-me container-fluid px-0">
      <div class="header d-flex justify-content-center align-items-center">
        <h1>Why choose me?</h1>
      </div>
      <div class="about-block">
        <div class="container-lg">
          <div class="row no-gutters py-4 justify-content-center values">
            <div class="col-12 col-md-6 col-lg text-left py-3 pr-md-2">
              <div class="value h-100">
                <div class="text-center">
                  <img src="@/assets/img/guide.jpg" />
                  <h2 class="text-center mt-2">Guidance</h2>
                </div>
                <div class="text align-items-center">
                  <p class="m-0">
                    I'm about helping you to build better business. Not just
                    closing a bunch of tickets in some fancy task manager app
                    🙂.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg text-left py-3 pl-md-2 pr-lg-2">
              <div class="value h-100">
                <div class="text-center">
                  <img src="@/assets/img/quality.jpg" />
                  <h2 class="text-center mt-2">Quality</h2>
                </div>
                <div class="text align-items-center">
                  <p class="m-0">
                    My next product is my best product. I always improve my
                    skills. So you can expect the best result every time.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg text-left py-3 pl-lg-2 pr-md-2">
              <div class="value h-100">
                <div class="text-center">
                  <img src="@/assets/img/own.jpg" />
                  <h2 class="text-center mt-2">Ownership</h2>
                </div>
                <div class="text align-items-center">
                  <p class="m-0">
                    I am responsible, accountable, and proud of my work.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg text-left py-3 pl-md-2 pr-lg-2">
              <div class="value h-100">
                <div class="text-center">
                  <img src="@/assets/img/expert.jpg" />
                  <h2 class="text-center mt-2">Expertise</h2>
                </div>
                <div class="text align-items-center">
                  <p class="m-0">
                    I tend to make the best use of every technology/niche I work
                    on.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg text-left py-3 pl-lg-2">
              <div class="value h-100">
                <div class="text-center">
                  <img src="@/assets/img/reliable.jpg" />
                  <h2 class="text-center mt-2">Reliability</h2>
                </div>
                <div class="text align-items-center">
                  <p class="m-0">
                    It's not just another gig for me. I'll be there to help you
                    support and grow your product.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters py-4 justify-content-center">
            <div class="col white text-left">
              <div class="info">
                <p>
                  <b>A developer</b> that can’t do anything but coding is just
                  no good. I aim to be a <b>tech partner</b> who can capture
                  your vision, and handle the technical part of a product to
                  make it true.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block block__stack container-fluid px-0">
      <div class="header d-flex justify-content-center align-items-center">
        <h1>My Tech Stack</h1>
      </div>
      <div class="about-block">
        <div class="container-lg">
          <tech-stack />
        </div>
      </div>
    </div>

    <div class="block block__lets-roll container-fluid px-0">
      <div class="header d-flex justify-content-center align-items-center">
        <h1>Let's roll!</h1>
      </div>
      <div class="about-block">
        <div class="container-lg">
          <div class="row no-gutters py-4 justify-content-center">
            <div class="col white text-left">
              <div class="info">
                <p>
                  If you're interested in building great things together -
                  <router-link :to="{ name: 'GetInTouch' }" class="link-ia">
                    <span data-hover="contact&nbsp;me">
                      contact me
                    </span>
                  </router-link>
                  for details
                </p>
                <p>
                  If you'd like to learn more - be sure to checkout my
                  <router-link :to="{ name: 'Portfolio' }" class="link-ia">
                    <span data-hover="portfolio">
                      portfolio
                    </span>
                  </router-link>
                  and
                  <router-link :to="{ name: 'Testimonials' }" class="link-ia">
                    <span data-hover="testimonials">
                      testimonials
                    </span>
                  </router-link>
                  page
                </p>
                <p>
                  I also share some of my thoughts and expertise in a

                  <router-link :to="{ name: 'Blog' }" class="link-ia">
                    <span data-hover="blog">
                      blog
                    </span> </router-link
                  >.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import isLoaded from "@/mixins/isLoaded";
import TechStack from "@/components/about/tech-stack/TechStack";
export default {
  components: { TechStack },
  mixins: [isLoaded],
  mounted() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        e.preventDefault();
        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth"
        });
      });
    });
  }
};
</script>
<style lang="scss">
.value {
  svg path {
    fill: none;
    stroke-width: 15px;
    stroke: #36b7ffb3;
  }
}
</style>

<style lang="scss" scoped>
section {
  display: block;
  .block {
    &__me {
      background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        url("~@/assets/img/intro.jpg");

      .about-block {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1481%26quot%3b)' fill='none'%3e%3cpath d='M122.33 647.51C240.6 646.17 348.93 515.29 576.59 515.25 804.25 515.21 803.72 585.25 1030.85 585.25 1257.98 585.25 1370.2 515.45 1485.11 515.25' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M415.08 613.58C530.81 607.21 617.29 399.17 825.84 398.62 1034.4 398.07 1031.23 468.62 1236.61 468.62 1441.99 468.62 1543.2 398.87 1647.37 398.62' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M884.35 663.28C1004.06 656.05 1065.12 449.85 1305.91 434.35 1546.7 418.85 1606.38 201.84 1727.47 193.55' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M563.5 665.92C678.87 638.92 644.5 331.27 898.68 330.86 1152.85 330.45 1395.2 513.98 1569.03 515.66' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M692.04 641.44C758.86 640.56 737.3 570.84 947.53 562.86 1157.75 554.88 1314.38 302.09 1458.5 294.06' stroke='rgba(86, 174, 253, 0.2)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1481'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
        background-position-x: right;
        background-position-y: bottom;
        background-repeat: no-repeat;
      }
    }
    &__intro {
      background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        url("~@/assets/img/journey.jpg");

      .about-block {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1488%26quot%3b)' fill='none'%3e%3cpath d='M1023.8-7.28C873.95-7.16 738.24 58.62 428.41 62.04 118.58 65.46-3.21 329.94-166.98 336.44' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M954.89-19.32C850.87-14.84 882.16 151.51 578.82 159.59 275.48 167.67 26.32 424.39-173.32 428.39' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M884.22-89.86C724.7-71.17 630.99 282.72 362.2 284.6 93.41 286.48-26.05 167.72-159.82 167' stroke='rgba(86, 174, 253, 0.2)' stroke-width='2'%3e%3c/path%3e%3cpath d='M1043.97-82.87C869.01-79.25 731.8 149.88 385.72 155.23 39.63 160.58-101.24 343.73-272.54 345.63' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M535.98-98.09C465.27-94.27 495.75 21.77 284.62 32.51 73.5 43.25-77.68 277.59-218.09 284.51' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1488'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
        background-position-x: left;
        background-position-y: top;
        background-repeat: no-repeat;
      }
    }
    &__why-me {
      background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        url("~@/assets/img/expertise.jpg");

      .about-block {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1473%26quot%3b)' fill='none'%3e%3cpath d='M-247.66 444.86C-107.86 441.69 77.12 248.43 276.23 248.86 475.33 249.29 439.47 540.17 538.17 574.32' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-54.81 70.63C49.8 70.88 151.46 140.63 357.74 140.63 564.01 140.63 537.93 57.91 770.29 70.63 1002.65 83.35 1028.91 520.3 1182.84 571.52' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-75.31 460.6C78.57 456.36 279.08 230.57 496.05 231 713.02 231.43 672.63 557.48 781.73 597.27' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-204.79 409.53C-35.8 407.39 193.63 212.23 442.19 213.53 690.75 214.83 642.48 581.17 765.68 625.62' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-240.53 144.04C-57.75 147.22 165.85 367.7 451.82 379.24 737.8 390.78 692.45 613.65 798 625.82' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1473'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
        background-position-x: left;
        background-position-y: bottom;
        background-repeat: no-repeat;
      }
    }
    &__stack {
      background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        url("~@/assets/img/tech-stack.jpg");

      .about-block {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1491%26quot%3b)' fill='none'%3e%3cpath d='M1554.89 313.47C1382.95 313.97 1228.28 439.71 878.25 436.67 528.22 433.63 408.01-22.06 201.61-45.93' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M1684.11 68.5C1489.18 70.23 1216.73 270.62 930.86 270.1 645 269.58 684-76.79 554.24-107.3' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M1651.2 20.19C1546.94 19.94 1445.63-49.81 1240.06-49.81 1034.5-49.81 1035.01 20.23 828.93 20.19 622.84 20.15 525.45-106.58 417.79-108.06' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M1514.5 266.4C1317.12 268.09 1050.5 471.9 751.13 468 451.76 464.1 522.93-16.44 369.45-84.42' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M1521.35 377.81C1372.59 376.41 1192.03 235.93 947.31 221.01 702.59 206.09 762.59-63.48 660.29-91.57' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1491'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
        background-position-x: right;
        background-position-y: top;
        background-repeat: no-repeat;
      }
    }
    &__lets-roll {
      background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        url("~@/assets/img/next.jpg");

      .about-block {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1640' height='720' preserveAspectRatio='none' viewBox='0 0 1640 720'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1520%26quot%3b)' fill='none'%3e%3cpath d='M-83.72 439.08C121.48 435.41 296.21 170.97 692.77 172.68 1089.33 174.39 1227.63 730.23 1469.26 762.37' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-311.49 666.84C-195.37 667.27-83.64 756.84 144.2 756.84 372.05 756.84 370.76 666.7 599.9 666.84 829.04 666.98 932.48 850.47 1055.59 854.07' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-268.3 176.44C-55.97 181.5 104.75 470.7 525.62 478.84 946.49 486.98 1110.87 733.57 1319.54 736.78' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-182.03 72.37C-30.97 75 120.11 228.14 390.18 266.77 660.24 305.4 554.02 678.9 676.28 746.27' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M-160.66 320.7C-23.64 321.01 109.65 410.7 379.96 410.7 650.27 410.7 638.34 317.21 920.59 320.7 1202.83 324.19 1292.36 712.83 1461.21 735.84' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1520'%3e%3crect width='1640' height='720' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
        background-position-x: left;
        background-position-y: bottom;
        background-repeat: no-repeat;
      }
    }

    background-size: cover;
    background-position: bottom;
    background-attachment: fixed;

    width: 100vw;
    .header {
      height: 20vh;
      h1 {
        text-shadow: 0 0 6px #000000;
      }
      @media (min-width: 812px) {
        height: 25vh;
        h1 {
          font-size: 3em;
        }
      }
      &__first {
        position: relative;
        height: 100vh;
        flex-direction: column;
        justify-content: space-between;
        * {
          text-shadow: 0 0 6px #000000;
        }
        blockquote {
          font-size: 2em;
        }
        small.copyright {
          display: block;
          text-align: right;
          font-size: 1em;
          margin-right: 2rem;
        }
        a {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 0.9em;
          color: #ffffff;
          position: absolute;
          bottom: 5rem;
          left: 0;

          animation: glow 2s linear infinite;
        }
      }
    }
    .about-block {
      display: flex;
      align-items: center;
      min-height: 80vh;
      @media (min-width: 812px) {
        min-height: 75vh;
        &__first {
          min-height: 65vh;
        }
      }
      background-color: #ffffff;
      color: #2a2d34;

      .img-wrap {
        overflow: hidden;
        height: 100%;
        img {
          transition: transform 0.7s ease;
          max-width: 100%;
          display: block;
        }
        &:hover {
          img {
            transform: scale(1.1);
          }
        }
      }
      .white {
        display: flex;
        box-shadow: 1px 1px 10px 0px rgb(0 0 0 / 11%);
        border-radius: 20px;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
      }
      .info {
        padding: 1rem 2rem;
        @media (min-width: 1025px) {
          padding: 2rem 1.5rem;
        }
        ul {
          list-style-type: none;
          padding-left: 0;
        }
        .link-ia {
          padding: 0;
          span {
            margin: 0;
            &::before {
              color: #2c3e50;
            }
          }
        }
      }
      .value {
        background-color: #ffffff;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 1px 1px 10px 0px rgb(0 0 0 / 11%);
        width: 100%;
        transition: all 0.4s ease;

        h2 {
          margin: 0.6rem 0 0.7rem;
        }
        img {
          width: 100%;
          height: 155px;
          object-fit: cover;
          object-position: center;
        }
        .text {
          @media (max-width: 992px) {
            padding: 0 2rem 2rem 2rem;
          }
          @media (min-width: 1025px) {
            padding: 0 1.5rem 2rem 1.5rem;
          }
        }
      }
      @media (min-width: 992px) {
        .values {
          .value {
            transition: all 0.4s ease;
            &:hover {
              cursor: pointer;
              transform: scale(1.04);
              box-shadow: 0 0px 20px 0px rgb(0 0 0 / 11%);
            }
          }
        }
      }
    }
    &:last-child {
      min-height: 100vh;
      .header {
        height: 30vh;
      }
      .about-block {
        min-height: 70vh;
      }
    }
  }
  .timeline {
    border-left: 3px solid #56afff;
    margin-left: 0;
    width: auto;

    > div {
      @media (max-width: 768px) {
        padding-left: 1rem !important;
      }
      &::after {
        content: " ";
        position: absolute;
        height: 16px;
        width: 16px;
        border: 3px solid #56afff;
        border-radius: 50%;
        background: #ffffff;
        top: 45%;
        left: -0.6rem;
      }

      .white {
        position: relative;
        font-weight: 500;
        justify-content: flex-start !important;
        &::before {
          content: attr(data-info);
          position: absolute;
          top: 0.5rem;
          left: 1rem;
          font-size: 2em;
          font-weight: bolder;
          color: #56aefd66;
        }
        small {
          margin-top: 0.5rem;
          display: block;
          color: #717171;
          font-weight: 400;
        }
      }
    }

    @media (min-width: 768px) {
      border-left: none;
      border-bottom: 3px solid #56afff;
      margin-left: auto;
      > div {
        .white {
          padding-top: 1.7rem !important;
          min-height: 220px;
        }

        &::before {
          content: " ";
          position: absolute;
          height: 16px;
          width: 16px;
          border: 3px solid #56afff;
          border-radius: 50%;
          background: #ffffff;
          bottom: -1rem;
          left: 47%;
        }
        &::after {
          content: unset;
        }
      }
    }
    @media (min-width: 992px) {
      .white {
        transition: all 0.4s ease;
        &:hover {
          transform: scale(1.04);
        }
      }
    }
  }
}
</style>
